import React, { useState, useEffect } from 'react';

import { useGetUpperTorsoFat } from 'api/services';
import ChartModal from 'components/ChartModal/ChartModal';
import { chartsKey } from 'utils/constants';

import { getGradientBackground } from './utils/chartColorizing';
import {
	defaultChartAxisValues,
	handleChartData,
	getChartMaxValue,
	increaseOrDecreaseMaxYThreshold,
} from './utils/chartHelpers';
import {
	defaultConfig,
	ticksCallbackPercentage,
	tooltipCallbackPercentage,
	styledChartElements,
} from './utils/customViewChart';

const UpperTorsoFat = ({ closeChart, isOpen }) => {
	const [data, setData] = useState({});
	const [chartConfig, setChartConfig] = useState(null);
	const [labelsData, setLabelsData] = useState(undefined);

	const { data: upperTorsoData, loading } = useGetUpperTorsoFat();
	const isDataAvailable =
		upperTorsoData?.data && upperTorsoData.data.length > 0;

	useEffect(() => {
		if (isDataAvailable) {
			const dataAdapted = handleChartData(upperTorsoData.data);

			setData(dataAdapted);
			setLabelsData(dataAdapted?.labels);
			handleChartConfig();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [upperTorsoData]);

	const getChartData = (canvas) => {
		const gradient = getGradientBackground(canvas);

		return {
			...data,
			datasets: [
				{
					data: data?.datasets[0]?.data,
					fill: true,
					backgroundColor: gradient,
				},
			],
		};
	};

	const handleChartConfig = () => {
		const minY = defaultChartAxisValues[chartsKey.upperTorsoFat].minY;
		let maxY = defaultChartAxisValues[chartsKey.upperTorsoFat].maxY;

		const maxValueOfY = getChartMaxValue(upperTorsoData.data, 'value');

		if (maxValueOfY && maxValueOfY >= maxY) {
			maxY = maxValueOfY + increaseOrDecreaseMaxYThreshold.large;
		}

		const config = {
			...defaultConfig,
			plugins: {
				...defaultConfig.plugins,
				tooltip: {
					...defaultConfig.plugins.tooltip,
					callbacks: { label: tooltipCallbackPercentage },
				},
			},
			elements: styledChartElements(upperTorsoData.data.length - 1),
			scales: {
				...defaultConfig.scales,
				y: {
					...defaultConfig.scales.y,
					min: minY,
					max: maxY,
					ticks: {
						...defaultConfig.scales.y.ticks,
						callback: ticksCallbackPercentage,
					},
				},
			},
		};

		setChartConfig(config);
	};

	return (
		<ChartModal
			loading={loading}
			data={getChartData}
			labelsData={labelsData}
			closeChart={closeChart}
			chartConfig={chartConfig}
			isOpen={isOpen}
		/>
	);
};

export default UpperTorsoFat;
